(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Flickity fixes the carousel viewport height at init, before the lazy-loaded
  // product images finish loading — which clips 2-line product titles. Recompute
  // once images (and layout) have settled.
  function resizeCarousels(){
    var els = document.querySelectorAll('.promo-carousel__carousel');
    for(var i = 0; i < els.length; i++){
      var c = els[i].carousel;
      if(c && typeof c.resize === 'function'){ c.resize(); }
    }
  }
  function watchImages(){
    var imgs = document.querySelectorAll('.promo-carousel__carousel img');
    for(var i = 0; i < imgs.length; i++){
      if(imgs[i].complete){ continue; }
      imgs[i].addEventListener('load', resizeCarousels, { once: true });
    }
  }
  function init(){
    watchImages();
    setTimeout(resizeCarousels, 250);
    setTimeout(resizeCarousels, 900);
    window.addEventListener('load', resizeCarousels);
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-coupons"] && !Shopify.designMode) return;
  try {
    
(function(){
  function flash(btn, label){
    if(!btn.getAttribute('data-label')){ btn.setAttribute('data-label', btn.textContent); }
    btn.textContent = label;
    btn.classList.add('is-copied');
    setTimeout(function(){ btn.textContent = btn.getAttribute('data-label'); btn.classList.remove('is-copied'); }, 1400);
  }
  function legacyCopy(text, btn){
    try{
      var ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.focus(); ta.select();
      document.execCommand('copy'); document.body.removeChild(ta);
      flash(btn, 'Copied');
    }catch(e){}
  }
  function onClick(e){
    var btn = e.currentTarget;
    if(btn.getAttribute('data-auto') === 'true'){ flash(btn, 'Applied'); return; }
    var code = btn.getAttribute('data-code') || '';
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(code).then(function(){ flash(btn, 'Copied'); }, function(){ legacyCopy(code, btn); });
    } else { legacyCopy(code, btn); }
  }
  function init(){
    var nodes = document.querySelectorAll('[js-copy-code]');
    for(var i = 0; i < nodes.length; i++){ nodes[i].addEventListener('click', onClick); }
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function set(el, sel, val){ var n = el.querySelector(sel); if(n){ n.textContent = pad(val); } }
  function tick(el){
    var raw = el.getAttribute('data-deadline');
    if(!raw){ return true; }
    var t = new Date(raw.replace(' ', 'T')).getTime();
    if(isNaN(t)){ return true; }
    var diff = t - Date.now();
    if(diff <= 0){
      var grid = el.querySelector('[js-cd-grid]');
      var expired = el.querySelector('[js-cd-expired]');
      if(el.getAttribute('data-expired') === 'hide'){
        el.style.display = 'none';
      } else {
        if(grid){ grid.style.display = 'none'; }
        if(expired){ expired.hidden = false; }
      }
      return true;
    }
    var s = Math.floor(diff / 1000);
    set(el, '[js-cd-days]', Math.floor(s / 86400));
    set(el, '[js-cd-hours]', Math.floor((s % 86400) / 3600));
    set(el, '[js-cd-mins]', Math.floor((s % 3600) / 60));
    set(el, '[js-cd-secs]', s % 60);
    return false;
  }
  function init(){
    var nodes = document.querySelectorAll('[js-promo-countdown]');
    for(var i = 0; i < nodes.length; i++){
      (function(el){
        if(tick(el)){ return; }
        var id = setInterval(function(){ if(tick(el)){ clearInterval(id); } }, 1000);
      })(nodes[i]);
    }
  }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();
})();
